import { map } from 'lodash';

import {
  FIELD_KEYS,
  INPUT_FIELD_TYPE_LABELS as FIELD_TYPES,
} from 'app/developer-v3/constants';

import type { FormFieldTemplate } from 'app/developer-v3/types';

export const getFormFields = (
  disallowedKeys: string[] = []
): FormFieldTemplate[] => [
  {
    type: 'single-line-string',
    key: FIELD_KEYS.key,
    label: 'Key',
    required: true,
    schemaKey: true,
    help_text_html:
      '<p>Enter a unique identifier for this input field using snake_case (lowercase with underscores). Match your API’s field name if possible. Used internally in Zapier. Example: <code>first_name</code>.</p>',
    disallowed: disallowedKeys,
    placeholder: 'first_name',
  },
  {
    type: 'single-line-string',
    key: FIELD_KEYS.label,
    label: 'Label',
    required: true,
    help_text_html:
      '<p>Enter a user-friendly name that describes the expected input. Capitalize each word. Displayed to users in the Zapier UI. Example: <code>First Name</code>.</>',
    placeholder: 'First Name',
  },
  {
    type: 'string',
    rows: 5,

    key: FIELD_KEYS.helpText,
    label: 'Help Text',
    min: 20,
    help_text_html:
      '<p>Provide a more detailed explanation of what users need to enter. Use Markdown to format text and link to help docs on your site where useful. Displayed to users in the Zapier UI. Example: <code>Filter by first name</code>. <a href="https://docs.zapier.com/platform/publish/integration-build-guidelines#trigger-input-fields" target="_blank">Learn more</a>.</p>',
    placeholder: 'Filter by first name',
  },
  {
    type: 'pretty-select',
    label: 'Type',
    help_text_html: '<p>What type of data does this input field collect?</p>',
    key: FIELD_KEYS.type,
    choices: map(FIELD_TYPES, (label, value) => ({ value, label })),
    default: 'string',
    hasSearch: false,
  },
  {
    type: 'single-line-string',
    key: FIELD_KEYS.default,
    label: 'Default Text',
    help_text_html:
      '<p>Enter a default value that makes sense if the user leaves this field blank. Use only if you’re confident it’s what most users would expect. <a href="https://docs.zapier.com/platform/publish/integration-build-guidelines#trigger-input-fields" target="_blank">Learn more</a>.</p>',
  },
  {
    type: 'fields',
    key: FIELD_KEYS.options,
    label: 'Options',
    fields: [
      {
        type: 'boolean-input',
        key: FIELD_KEYS.required,
        label: 'Required',
      },
      {
        type: 'boolean-input',
        key: FIELD_KEYS.list,
        label: 'Allows Multiples',
      },
      {
        type: 'boolean-input',
        key: FIELD_KEYS.altersDynamicFields,
        label: 'Alters Dynamic Fields',
      },
    ],
  },
];
